jQuery('#blindsOnRightContent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true,
    appendDots: jQuery('#blindsOnRightContentDots'),
});

jQuery('.staggered-content-blinds-on-right .hotspot').click(function() {
    switch (jQuery('.staggered-content-blinds-on-right .image-container').attr('data-status')) {
        case 'open':
            jQuery('.staggered-content-blinds-on-right .image-container').attr('data-status', 'closed');

            var closingImage = jQuery('.staggered-content-blinds-on-right #blindsOpening').attr('data-image-open');
            var openingVideo = jQuery('.staggered-content-blinds-on-right #blindsOpening').attr('data-video-closed');

            document.getElementById('blindsOpening').setAttribute('src', openingVideo);
            document.getElementById('blindsOpening').setAttribute('poster', closingImage);

            document.getElementById('blindsOpening').play();

            break;
        case 'closed':
            jQuery('.staggered-content-blinds-on-right .image-container').attr('data-status', 'open');

            var openingImage = jQuery('.staggered-content-blinds-on-right #blindsOpening').attr('data-image-closed');
            var closingVideo = jQuery('.staggered-content-blinds-on-right #blindsOpening').attr('data-video-open');

            // jQuery('.staggered-content-blinds-on-right #blindsOpening source').attr('src', closingVideo);
            document.getElementById('blindsOpening').setAttribute('src', closingVideo);
            document.getElementById('blindsOpening').setAttribute('poster', openingImage);

            document.getElementById('blindsOpening').play();

            break;
    }
});

jQuery(document).ready(function() {
    if (jQuery(window).width() < 768) {
        jQuery('.staggered-content-lights-on-right .image-container').insertBefore('.staggered-content-lights-on-right .slider-container');
    }
});

jQuery('.staggered-content-blinds-on-right video').click(function(e) {
    e.preventDefault();
});